export const ROLES = ['ROLE_USER', 'ROLE_EDITOR', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'] as const

export type Role = (typeof ROLES)[number]

export const MIN_ACCESS_ROLE: Role = 'ROLE_EDITOR'

export function hasRole(roles: readonly string[], required: Role): boolean {
  const requiredRank = ROLES.indexOf(required)
  return roles.some((role) => ROLES.indexOf(role as Role) >= requiredRank)
}

export function canAccessAdmin(roles: readonly string[]): boolean {
  return hasRole(roles, MIN_ACCESS_ROLE)
}
